export const videoContainer = "v1ivo4ia";
export const video = "v1kljfp5";
export const infoBlock = "i145uai1";
export const info = "iqv8q2e";

require("./style.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");